import _ from 'underscore';
import moment from 'moment';

import config from 'src/config';

bookingHelperService.$inject = [
  '$rootScope',
  'jsSdk.keychain'
];

export default function bookingHelperService($rootScope, jsSdkKeychain) {
  class BookingHelperService {
    isValid(booking) { //eslint-disable-line
      return _.includes(['CANCELLED', 'PROCESSED', 'WAITING'], booking.status);
    }
    isCancelled(booking) { //eslint-disable-line
      return _.includes(['CANCELLED', 'VOIDED', 'EXPIRED'], booking.status);
    }
    isTicket(booking) { //eslint-disable-line
      if (!booking) return false;
      return _.includes(['TICKET', 'COVER'], booking.inventoryType);
    }
    isTable(booking) { //eslint-disable-line
      if (!booking) return false;
      return _.includes(['TABLE', 'PACKAGE'], booking.inventoryType);
    }
    isGuestCheckout(booking) { //eslint-disable-line
      if (!booking) return false;
      return booking && booking.primaryUser && booking.primaryUser.user === null;
    }
    isReservation(booking) { //eslint-disable-line
      if (!booking) return null;

      return booking.payment === 'VENUE';
    }
    isUpcomingBooking(booking) { //eslint-disable-line
      if (!booking) return false;

      return moment(booking.date).startOf('day') >= moment().startOf('day');
    }
    isPastBooking(booking) { //eslint-disable-line
      if (!booking) return false;
      return moment(booking.date).startOf('day') < moment().startOf('day');
    }
    findBookingUser(booking) { //eslint-disable-line
      if (!booking) return null;

      return _.find(booking.users, function(user) {
        const myUserId = $rootScope.currentUser.id;

        if (user && user.user && user.user.id) {
          return user.user.id === myUserId;
        } else if (user && user.user) {
          return user.user === myUserId;
        }

        return null;
      });
    }
    findPrimaryBooker(booking) { //eslint-disable-line
      if (!booking) return null;

      return _.find(booking.users, function(user) {
        return user.type === 'MAIN';
      });
    }
    getStatusText(booking) { //eslint-disable-line
      if (this.isUpcomingBooking(booking)) {
        return 'Complete';
      }

      if (this.isReservation(booking) && this.isUpcomingBooking(booking)) {
        return 'Reserved. Pay at the venue.';
      }

      if (booking.status === 'COMPLETE' || booking.status === 'PROCESSED') {
        return 'Complete';
      }

      if (!this.isValid(booking)) {
        return 'Cancelled';
      }

      return 'Pending booking...';
    }
    getPaymentStatusText() { //eslint-disable-line
      return 'feature in progress....';
    }
    hasTickets(booking) { //eslint-disable-line
      if (!booking) return false;
      return (booking.hasTickets) ? booking.hasTickets : false;
    }
    downloadTicketLink(booking) { //eslint-disable-line
      if (!booking) return null;

      const apiURL = config.SDK_API_URL;

      return `${apiURL}/booking/${booking.id}/ticket/print?auth=${jsSdkKeychain.getConsumerAuthToken()}`;
    }
    getStatus(booking) {
      if (!booking) return null;

      const status = {
        _booking: booking,
        _users: {
          bookingUser: this.findBookingUser(booking),
          bookingUserPrimary: this.findPrimaryBooker(booking)
        },
        isValid: this.isValid(booking),
        isCancelled: this.isCancelled(booking),
        isTicket: this.isTicket(booking),
        isTable: this.isTable(booking),
        isGuestCheckout: this.isGuestCheckout(booking),
        isReservation: this.isReservation(booking),
        isUpcoming: this.isUpcomingBooking(booking),
        isPast: this.isPastBooking(booking),
        hasTickets: this.hasTickets(booking)
      };

      return status;
    }
  }

  return new BookingHelperService();
}



// WEBPACK FOOTER //
// ./src/services/bookingHelpersService.js